module.exports = __webpack_public_path__ + "img/bolter-gun.575ac367.svg";